<template>
  <div id="join_us" v-if="loaded" :key="loaded">
    <div class="wrapper">
      <div class="forms">
        <div id="form">
          <activateNumber v-if="step === 1" :step="step" :numbers="numbers" :personalInfo="personalInfo" @numberActivated="finishNumber" @qrActivated="qrActivated" @sendOtpForMobility="sendOtpForMobility" :allowMobility="allowMobility" :otpConfirmed="otpConfirmed"/>
          <template v-if="step === 2">
              <sendOtp  :phoneNumber="phoneNumber" @success="successOtpSend" @sendOtp="sendOtp" />
          </template>
          <validateOtp :activeItem="item_for_mobility" v-if="step === 3" :phoneNumber="phoneNumber" @success="validateOtp" />
          <activateQr v-if="step === 4" :qrCode="qrCode"/>
        </div>
      </div>
    </div>
    <div id="back_image">
      <div id="white_logo"></div>
    </div>
  </div>
</template>
<script>
import activateNumber from '@/components/activate/activateNumber.vue'
import activateQr from '@/components/activate/qrActivation.vue'
import sendOtp from '@/components/OTP/sendOtp.vue'
import validateOtp from '@/components/OTP/validateOtp.vue'


export default {
  components: { activateNumber, sendOtp ,validateOtp, activateQr},
  data() {
    return {
      step: 1,
      deletedPrice: 0,
      phoneNumber: 0,
      loaded: false,
      cartOpen: !this.isMobile(),
      total: 0,
      form: {},
      numbers: [],
      item_for_mobility: {},
      personalInfo: {},
      skipPay: false,
      allowMobility: false,
      numberOfSteps:5,
      qrCode:'',
      otpConfirmed: false
    }
  },
  mounted() {
    
        this.loadData();
     
   
  },
  computed: {
    words() {
      return this.$store.state.words
    },
    
  },
  methods: {
 
    sendOtp(item = false){
      if(item != false)
      {
        if( item.type &&  item.type != '') this.otpType = item.type;
        if( item.phoneNumber &&  item.phoneNumber != ''){
          this.otpPhone = item.phoneNumber;
          this.phoneNumber = item.phoneNumber;
        }
        
      }
      

      this.api({ action: 'api/send_otp', data: { number:this.otpPhone ,type: this.otpType}}, (data) => {
                if(data.data.error && data.data.error != "")
					{
						this.activateError(data.data.error);
					}
                    else{
                        if(data.data)
                        {
                            // this.$emit("success" , phoneNumber);
                            this.step = 3;
                        }
                        else{
                            this.activateError(this.$store.state.words.goto_help);
                        }
                    }
                });
    },
    validateOtp(){
      this.otpConfirmed = true;
      this.step = 1;
    },
    finishNumber(number){

      this.allowMobility = false;
    },
    loadData(){
          this.$store.commit('setIsLoading', {isLoading: true});
          this.loaded = false;
          this.api({ action: 'cart/get_open_order_numbers'}, (data) => {
          if(data.data.error && data.data.error != "")
          {
            this.activateError(data.data.error);
          }
          else{
            if(!data.data.length > 0)
              {
                this.loaded = true;
                this.$store.commit('setIsLoading', {isLoading: false})

                this.$swal({
                icon:  'info',
                title: this.$store.state.words.no_numbers_av,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'הפעלה ממספר אחר',
                denyButtonText: 'חזרה לדף הבית',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.step = 2;
                } else if (result.isDenied) {
                document.location = '/';
                }
              });
              
              }
            else{
                this.numbers = data.data;
                this.loaded = true;
                this.$store.commit('setIsLoading', {isLoading: false})
               
              }
            }
    
          });
        
        },
        sendOtpForMobility(item){
          this.item_for_mobility = {};
          this.item_for_mobility = item;
          this.phoneNumber = item.number;
          this.step = 2;
          this.allowMobility = true;
        },
        qrActivated(qrCode){
          this.qrCode = qrCode;
          this.step = 4;
        },
  },
}
</script>
